import {createContext, useContext} from "react";
import {AdvertDetailQueryResult} from "@gql/query/advert/detail.gql";

type DetailContext = {
    advert: NonNullable<AdvertDetailQueryResult["data"]>["advert"] | null;
    isRk: boolean;
    banner: 'cez' | 'upc' | 'o2' | null;
}

export const AdvertDetailContext = createContext<DetailContext>({
    advert: null,
    isRk: false,
    banner: null,
});

export const useAdvertDetail = () => {
    return useContext(AdvertDetailContext);
}
